<template>
    <div class="small">
        <div class="text-info px-3 px-lg-5">
            <router-link :to="{ path: '/terms-of-use', query: { lang: this.lang } }" class="text-info">
                {{ renLangSet[lang].auth.label_agreement2 || '_TERMS_' }}
            </router-link>
            <span class="mx-2 mx-lg-3">◉</span>
            <router-link :to="{ path: '/privacy-policy', query: { lang: this.lang } }" class="text-info">
                {{ renLangSet[lang].auth.label_agreement3 || '_PRIVACY_' }}
            </router-link>
            <span class="mx-2 mx-lg-3">◉</span>
            <router-link :to="{ path: '/user-deletion-policy', query: { lang: this.lang } }" class="text-info">
                {{ renLangSet[lang].auth.label_agreement4 || '_DELETION_' }}
            </router-link>
        </div>
        <div class="mt-3">v{{ about.appVersion }} © 2025 The Mon Language မန်. Developed by Barnista. All Rights Reserved.</div>
    </div>
</template>

<script>
import about from '@/services/abouts/about';
import renaissanceLanguages from '@/assets/data/localizations/renaissance-languages';

export default {
    name: 'comp-footer',
    props: {
        lang: {
            type: String,
            default: 'en'
        }
    },
    data() {
        return {
            about: about,
            renLangSet: renaissanceLanguages.langSet
        }
    },
}
</script>